
/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 16/9/2020
 */

import formRoutes from "@/router/resources/formRoutes";
import localToolsRoutes from "@/router/resources/localToolsRoutes";
import mergeProps from "@/router/utils/mergeProps";
import eventTypeSettingsRoutesFn from "@/router/scheduler/eventTypeSettingsRoutesFn";
import redirectByName from "@/router/utils/redirectByName.js";

let EmptyRouterView = () => import(/* webpackChunkName: "ResourceCenter" */ '@/core/components/EmptyRouterView.vue')

let ResourcesMain = () => import(/* webpackChunkName: "ResourceCenter" */ '@/core/modules/coach/Resources/ResourcesMain.vue')
let WorkflowDetails = () => import(/* webpackChunkName: "ResourceCenter" */ '@/core/modules/coach/Resources/Workflows/WorkflowDetails.vue')

export default [



	{
		path: 'resources/workflows/:workflowId',
		name: 'WorkflowDetails',
		component: WorkflowDetails,
		meta: {resourceTab: "workflows"},
		props: mergeProps,
		children:[
			...eventTypeSettingsRoutesFn({
				mainRouteName: "WorkflowDetailsEventType",
				backRouteName: "WorkflowDetails",
				schedulerGeneralAvailabilityRoute: "SchedulerGeneralAvailability"
			})
		]

	},

	{
		path: 'resources',
		name: 'ResourcesRoot',
		component: EmptyRouterView,
		redirect: redirectByName('ResourcesTabs', {resourceTab: 'files'}),
		props: mergeProps,
		children:[
			...formRoutes,
			...localToolsRoutes,
			{
				path: ':resourceTab',
				// path: ':activeTab',
				name: "ResourcesTabs",
				component: ResourcesMain,
				props: mergeProps,
			},

		]
	},

	{
		path: 'resources',
		name: "ResourcesForms",
		redirect: redirectByName("ResourcesTabs", {resourceTab: "forms"}),
	},
	{
		path: 'resources',
		name: "ResourcesToolsRouteName",
		redirect: redirectByName("ResourcesTabs", {resourceTab: "tools"}),
	},
	{
		path: 'resources',
		name: "ResourcesLegalDocs",
		redirect: redirectByName("ResourcesTabs", {resourceTab: "agreements"}),
	},

]
